export function getCompactNumberStr(iops: number): string {
  if (iops < 1000) return Math.round(iops).toString();
  if (iops < 1000000) return `${(iops / 1000).toFixed(1)}K`;
  if (iops < 1000000000) return `${(iops / 1000000).toFixed(1)}M`;
  if (iops < 1000000000000) return `${(iops / 1000000000).toFixed(1)}B`;
  return `${(iops / 1000000000000).toFixed(1)}T`;
}